import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 relative z-10 bg-[#0a0a0a] border-t border-white/5" data-id="element-14" data-mp="356lspbj3cb5u">
      <div className="max-w-7xl mx-auto px-6" data-id="element-15" data-mp="318o0dzu0x8y8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-16" data-mp="2w88pdex7sdjf">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-17" data-mp="3sy9drcto8s07">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6" data-id="element-18" data-mp="3f6cn7d7niq5x">
              Get Your Free <br data-id="element-19" data-mp="3f4i9ojypm0bv" /> Quote Today
            </h2>
            <p className="text-gray-400 text-lg mb-12" data-id="element-20" data-mp="ghe2ougdbsni">
              Whether you need an emergency repair or a quote for a new boiler,
              our team is ready to help.
            </p>

            <div className="space-y-8" data-id="element-21" data-mp="3jwmbwplcrl46">
              <div className="flex items-start gap-4" data-id="element-22" data-mp="3jxnzftjk202s">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-23" data-mp="3ouxp9aauwdr5">
                  <Phone className="w-5 h-5 text-[#FFD600]" data-id="element-24" data-mp="3b2hranwtb5x3" />
                </div>
                <div data-id="element-25" data-mp="3f3t761pvwcs3">
                  <h4 className="text-white font-bold mb-1" data-id="element-26" data-mp="3f3bfzji2wor1">Call Us (24/7)</h4>
                  <a href="tel:07708233554" className="text-gray-400 hover:text-[#FFD600] transition-colors text-lg" data-id="element-27" data-mp="3141woaykteiu">
                    07708 233554
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-28" data-mp="2w5qridj87s6y">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-29" data-mp="2w6a6bldky0gr">
                  <Mail className="w-5 h-5 text-[#FFD600]" data-id="element-30" data-mp="qb7ionhmc57l" />
                </div>
                <div data-id="element-31" data-mp="udud8w5oc48h">
                  <h4 className="text-white font-bold mb-1" data-id="element-32" data-mp="ucaumywjph3j">Email Us</h4>
                  <a href="mailto:Clydesidegasandheating@gmail.com" className="text-gray-400 hover:text-[#FFD600] transition-colors break-all" data-id="element-33" data-mp="23cvjgtjp0r0r">
                    Clydesidegasandheating@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-34" data-mp="1pe5llbp1unbc">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0" data-id="element-35" data-mp="2m0s4hshjqcgg">
                  <Clock className="w-5 h-5 text-[#FFD600]" data-id="element-36" data-mp="2i104i467xemp" />
                </div>
                <div data-id="element-37" data-mp="2d8gs3aj9opjh">
                  <h4 className="text-white font-bold mb-1" data-id="element-38" data-mp="2d7xajuxj435z">Working Hours</h4>
                  <p className="text-gray-400" data-id="element-39" data-mp="289vrvb40m5v1">Mon - Fri: 8:00 AM - 6:00 PM</p>
                  <p className="text-gray-400" data-id="element-40" data-mp="35qavwv1ohwo6">Sat: 9:00 AM - 4:00 PM</p>
                  <p className="text-[#FFD600] font-medium mt-1" data-id="element-41" data-mp="30zcc3lhhegg6">
                    24/7 Emergency Callouts Available
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-white/10 rounded-3xl p-8" data-id="element-42" data-mp="3da3pkbnb4vuf">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-43" data-mp="2s7p7n1jhrv">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-44" data-mp="p7jus6c89f">
                <div className="space-y-2" data-id="element-45" data-mp="4ua89ul5jgcb">
                  <label className="text-sm font-medium text-gray-400" data-id="element-46" data-mp="9sljo9r3hywn">
                    Full Name
                  </label>
                  <input type="text" className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors" placeholder="John Doe" data-id="element-47" data-mp="dvhuvfeb2sqk" />
                </div>
                <div className="space-y-2" data-id="element-48" data-mp="1462gr6gkfoj">
                  <label className="text-sm font-medium text-gray-400" data-id="element-49" data-mp="13eiyeq4y8em">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors" placeholder="07123 456789" data-id="element-50" data-mp="9x13t9st1r91" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-51" data-mp="3scbpm4yh7elj">
                <label className="text-sm font-medium text-gray-400" data-id="element-52" data-mp="3ncfgxseu2yzn">
                  Email Address
                </label>
                <input type="email" className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors" placeholder="john@example.com" data-id="element-53" data-mp="17ki6v9zvitsk" />
              </div>

              <div className="space-y-2" data-id="element-54" data-mp="2pj6dbpuvygcb">
                <label className="text-sm font-medium text-gray-400" data-id="element-55" data-mp="2pgtn6pez4zo6">
                  Service Required
                </label>
                <select className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors appearance-none" data-id="element-56" data-mp="2ghyhrfjr7tlx">
                  <option data-id="element-57" data-mp="389edbz3agqoa">Boiler Installation</option>
                  <option data-id="element-58" data-mp="3884e36kp9cg2">Boiler Repair</option>
                  <option data-id="element-59" data-mp="2ui0uknd7fwub">Servicing & Maintenance</option>
                  <option data-id="element-60" data-mp="2uhhnk1p3esv2">Gas Safety Certificate</option>
                  <option data-id="element-61" data-mp="2zgkigtbczipb">Emergency Callout</option>
                  <option data-id="element-62" data-mp="2zf9ht2d7mr2f">Other</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-63" data-mp="3n53rjb28fzig">
                <label className="text-sm font-medium text-gray-400" data-id="element-64" data-mp="3rxesmh8plrcl">
                  Message
                </label>
                <textarea rows={4} className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-[#FF9500] transition-colors resize-none" placeholder="Tell us about your heating issue..." data-id="element-65" data-mp="5oj05aeufr54"></textarea>
              </div>

              <button type="submit" className="w-full bg-gradient-primary text-black font-bold text-lg py-4 rounded-xl hover:shadow-[0_0_20px_rgba(255,149,0,0.3)] transition-all duration-300" data-id="element-66" data-mp="3mvuye4lrrqhd">
                Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}